<template>
  <div :class="{ hide: !show }" class="modal-overlay w-full h-full">
    <div class="popup relative">
      <popup-header title="Book a Meeting" @close="closePopup" />
      <div class="popup__content popup__content--book-meeting">
        <div class="loading">
          <div class="lds-ripple !translate-x-full !translate-y-full">
            <div></div>
            <div></div>
          </div>
        </div>
        <div
          class="calendly-inline-widget z-10"
          data-url="https://calendly.com/momentum-suite/softwaretesting"
          style="min-width: 320px; height: 630px"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import PopupHeader from "@/components/PopupHeader";
export default {
  name: "BookMeeting",
  components: { PopupHeader },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closePopup() {
      this.$emit("close");
    },
  },
  computed: {
    hasEmbedded() {
      return document
        .getElementsByClassName("calendly-inline-widget")[0]
        .hasChildNodes();
    },
  },
  watch: {
    show: {
      handler(value) {
        if (value && !window.Calendly) {
          const script = document.createElement("script");
          script.src = "https://assets.calendly.com/assets/external/widget.js";
          document.body.appendChild(script);
        }
      },
    },
  },
};
</script>

<style scoped>
.hide {
  @apply hidden;
}
.popup__content--book-meeting {
  @apply flex justify-center px-8 w-[320px]  min-h-[480px] md:w-[800px] xl:w-[1100px];
}
.loading {
  @apply absolute -left-10 -top-8 h-full w-full flex items-center justify-center;
}
</style>
